export default {
  generic: {
    success: {
      text: 'Successful',
      type: 'info',
    },
    error: {
      text: 'Oops something went wrong, please try again',
      type: 'warning',
    },
  },
  // Form Errors (vuelidate)
  formValidation: {
    required: (field) => `${field} is required `,
    minLength: (field, number) => `${field} needs to be at least ${number.min} characters`,
    maxLength: (field, number) => `${field} exceeds the ${number.max} character limit for SMS.`,
    minValue: (field, value) => (typeof value.min === 'number' ? `${field} must be no less than ${value.min}` : `${field} cannot be in the past`),
    url: (field) => `${field} must be a URL`,
  },
  campaigns: {
    noData: {
      heading: 'No SMS Campaigns created',
      message: 'You haven\'t created any SMS campaigns click create campaign to get started',
    },
  },
  transactionalEvents: {
    noData: {
      heading: 'No transactional events to list',
      message: 'You haven\'t setup any Akkroo event with a sms integration.',
    },
  },
  smsMessage: {
    noData: {
      heading: 'No SMS Messages created',
      message: 'You haven\'t created any SMS Messages click create message to get started',
    },
  },
  contact: {
    noData: {
      heading: 'No Contact List created',
      message: 'You haven\'t created any Contact List click Create New Contact to get started',
    },
  },
  // Messages
  message: {
    create: {
      success: (name) => ({
        text: `${name} created`,
        type: 'info',
      }),
      error: {
        text: 'Something went wrong please try again',
        type: 'warning',
      },
    },
    update: {
      success: (name) => ({
        text: `${name} updated`,
        type: 'info',
      }),
    },
  },
  shortCodes: {
    success: {
      text: 'Custom field copied',
      type: 'info',
    },
    error: {
      text: 'Oops something went wrong, please try again',
      type: 'warning',
    },
  },
};
